import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { ILoanStatusCard, LoanStatusCardConfig, LoanStatusCardType } from '../models/loan-status-card.model';

export interface CmgLoanBannerStatusCardState extends EntityState<ILoanStatusCard, LoanStatusCardType> {
  cardType: LoanStatusCardType;
}

function createInitialState(): ILoanStatusCard {
  return <ILoanStatusCard>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-loan-banner-status-card-store', idKey: 'cardType' })
export class CmgLoanBannerStatusCardStore extends EntityStore<CmgLoanBannerStatusCardState> {
  constructor() {
    super(createInitialState());
    this.add(LoanStatusCardConfig);
  }
}
